import React, { useState } from 'react';
import BreadcrumbComp from '@components/UI/Breadcrumb/Index.jsx';
import FilterSolicitacaoUnidadeGerencia from "@components/Solicitacao/User/Consultar/Filter.jsx";
import { useGenericReducer } from '@hooks/state/useGenericReducer.js';
import GridConsultasSolicitacoesUnidadeGerencia from '@components/Solicitacao/User/Consultar/Grid.jsx';
import PageWrapper from '@components/UI/PageWrapper/Index.jsx';
import { useAppAuth } from '@contexts/AuthContext';

function ConsultarSolicitacoesUnidadeGerencia() {
  const { nomeUnidadeGerencia } = useAppAuth();
  const NomeForm = `Consultar Solicitações ${nomeUnidadeGerencia}`;
  const { state, setData, deleteItem } = useGenericReducer();
  
  const [filters, setFilters] = useState({
    tipoCompliance: "",
    numeroSolicitacao: "",
    dataSolicitacaoInicial: "",
    dataSolicitacaoFinal: "",
    nomeAuditor: "",
    nomeProcesso: "",
    statusSolicitacao: null,
  });

  return (
    <PageWrapper>
      <div className="row">
        <BreadcrumbComp Param1="Home" Param2="Solicitações e Pendências" Param3={NomeForm} />
        <div className="col-12 col-md-12">
          <div className="block h-auto">
            <div className="container-fluid">
              <div className="row">

                <div className="col-12 col-md-6 d-flex align-items-center">
                  <i className="fa-solid fa-filter filter-icon"></i>
                  <h2 className="mb-0 p-2">Filtros</h2>
                </div>

                <div className="col-12 col-md-6 d-flex align-items-center justify-content-end">
                  <button className="btn btn-menu">
                    <i className="fa-solid fa-bars"></i>
                  </button>
                </div>

                <FilterSolicitacaoUnidadeGerencia
                  setFilters={setFilters}
                />

                <GridConsultasSolicitacoesUnidadeGerencia
                  state={state}
                  setData={setData}
                  filters={filters}
                  onDelete={deleteItem}
                />

              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default ConsultarSolicitacoesUnidadeGerencia;
